// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBell = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M11 5.083A6 6 0 006 11v3l-2 3v2h5.17a3.001 3.001 0 005.66 0H20v-2l-2-3v-3a6 6 0 00-5-5.917V3h-2zM12 7a4 4 0 00-4 4v3.606L6.404 17h11.192L16 14.606V11a4 4 0 00-4-4"
    />
  );
export default SvgIconBell;
